const builderCtaText = 'Get started';

export default builderCtaText;
